export function xrayLicensesDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.LICENSES + '/:param')
        .setCustomActions({
            'getNames': {
                method: 'GET',
                isArray: true
            },
            'setLicense': {
                method: 'POST',
                notifications:true
            },
            'getInfo': {
                method: 'GET',
                params: {param: '@licenseID'}
            },
            'getReports': {
                method: 'GET',
                path: XRAY_RESOURCE.GET_LICENSE_REPORT
            },
            'getComponents': {
                method: 'GET',
                path: XRAY_RESOURCE.GET_LICENSE_REPORT + '/components'
            },
            'getStatus': {
                method: 'GET',
                path: XRAY_RESOURCE.GET_LICENSE_REPORT + '/status'
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/licenses_dao.js